import { CheckCircleOutlineRounded, CircleOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useReviewFormSubmissionInOneOnOne, type FormSubmissionDetailDto } from "src/http";
import { ItemProperty } from "../itemProperties";
import { MaterialSymbolIcon, MaterialSymbols } from "../MaterialSymbolIcon";

interface Props {
  formSubmission: FormSubmissionDetailDto;
}

const FormSubmissionReviewedInOneOnOneProperty = (props: Props) => {
  const { mutate: markAsReviewedInOneOnOne, isLoading } = useReviewFormSubmissionInOneOnOne();

  function handleReviewClicked() {
    markAsReviewedInOneOnOne({
      formSubmissionGuid: props.formSubmission.formSubmissionGuid,
    });
  }

  return (
    <ItemProperty labelIcon={<MaterialSymbolIcon symbol={MaterialSymbols.ThumbsUpDouble} />} label="Reviewed in 1:1">
      <Button
        variant="tertiary"
        onClick={handleReviewClicked}
        startIcon={props.formSubmission.reviewedInOneOnOne ? <CheckCircleOutlineRounded /> : <CircleOutlined />}
        disabled={isLoading || props.formSubmission.reviewedInOneOnOne}
        sx={{ alignSelf: "start" }}
      >
        {props.formSubmission.reviewedInOneOnOne ? "Reviewed" : "Mark as Reviewed"}
      </Button>
    </ItemProperty>
  );
};

export { FormSubmissionReviewedInOneOnOneProperty };
